/**
 * @owner @Appboy/in-app-messages
 */

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const submittedSurveyWorkflowStepFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("submitted_survey_workflow_step_filter"),
  comparison_key: z.enum(["7", "8"]),
  display_name: z.string(),
  has_hard_deleted_data: z.literal(true).optional(),
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    pre_filter_value: z
      .object({
        expired: z.boolean(),
        id: common.objectId,
        value: z.string(),
      })
      .optional(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
